<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    getChannels () {
      this.$store.dispatch('getChannels')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getChannels()
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Channels.vue?0b96aa18